import React, { useContext, useState, useEffect } from "react";
import Swiper from "react-id-swiper";
import ImageSliderOneSingle from "../../components/image-slider/ImageSliderOneSingle";
import ImageEditIcon from "../../pages/imageSlider/ImageEditIcon"
import AutoSlider from "./AutoSlider"
import { AuthContext } from "../../common/Auth"

const ImageSliderOne = () => {

  const {imagesList, themeSettingsData} = useContext(AuthContext)
  const [data, setData] = useState({})
  const [imageSliderId, setImageSliderId] = useState("")

  useEffect(() => {
    themeSettingsData.map((i) => {
      if (i.settingsName === "imageSlider") {
        setData(i.values[0]);
        setImageSliderId(i._id);
      }
    })
  }, [themeSettingsData])

  let pt = data.paddingTop ? data.paddingTop : "pt-50";
  let pb = data.paddingBottom ? data.paddingBottom : "pb-50";
  let mb = data.marginBottom ? data.marginBottom : "mb-50";
  let mt = data.marginTop ? data.marginTop : "mt-50";
  let mr = data.marginRight ? data.marginRight : "mr-0";
  let ml = data.marginLeft ? data.marginLeft : "ml-0";
  let pl = data.paddingLeft ? data.paddingLeft : "pl-0";
  let pr = data.paddingRight ? data.paddingRight : "pr-0";
  let wi = data.width ? data.width : 260;
  let fullSection = data.fullSection ? "container-fluid" : "container";
  let bgImage = data?.bgImage ? data?.bgImage : "";
  let bgColor = data?.bgColor ? data?.bgColor : "";
  let autoPlay = data.autoPlay
  let showButton = data.showButton

  let totalImages = Object.keys(imagesList).length;
  let allowSlidePrev = true;
  let allowSlideNext = true;
  switch(wi) {
    case 127 :  
      if(totalImages <= 8) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
    case 145 :  
      if(totalImages <= 7) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
    case 170 :  
      if(totalImages <= 6) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
    case 205 :  
      if(totalImages <= 5) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
    case 260 :  
      if(totalImages <= 4) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
    case 345 :  
      if(totalImages <= 3) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
    case 520 :  
      if(totalImages <= 2) {
        allowSlideNext = false;
        allowSlidePrev = false;
        showButton = false;
      }
      break;
  }

  let showButtonSettings = {}
  if (showButton) {
    showButtonSettings = {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  }

  let settings = {
    loop: false,
    spaceBetween: 10,
    navigation: showButtonSettings,
    width: wi ? wi : 260,
    allowSlidePrev: allowSlidePrev,
    allowSlideNext: allowSlideNext,
    containerClass: "antera-image-swiper"
  }

  const SwiperData = () => {
     return (
      <Swiper {...settings}>
        {Object.keys(imagesList).length > 0 &&
          imagesList.map((single, key) => {
            return (
              <ImageSliderOneSingle
                data={single}
                key={key}
                sliderClass="swiper-slide"
              />
            )
          })}
      </Swiper>
     )
  }
  return (
    <div className={`antera-image-slider-section-container collections-area categorySlider image-Slider-container section-bgImage ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`} 
    style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}} >
      <div className="edit-inline">
        <ImageEditIcon imageId={imageSliderId} fromEditAction="topBottomSpace" />
      </div>
      <div className={`antera-image-slider-content-container ${fullSection}`}>
        <div className="collection-wrap">
          <div className="antera-image-slider-content collection-active">
            {autoPlay ? <AutoSlider imagesList={imagesList} showButton={showButton} /> : 
            <>
              {showButton && <SwiperData /> }
              {!showButton && <SwiperData /> }
            </>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSliderOne;
